{
  "slug": "what-is-iq",
  "title": "IQ क्या है?",
  "description": "IQ का मतलब क्या है, IQ परीक्षण क्या मापता है और बुद्धि गुणांक स्कोर की महत्वपूर्ण सीमाएं सीखना।",
  "summary": "IQ, बुद्धि गुणांक के लिए छोटा, एक मानकीकृत स्कोर है जो एक समान उम्र के लोगों की तुलना में चुने गए संज्ञानात्मक कार्यों पर प्रदर्शन का वर्णन करने के लिए डिज़ाइन किया गया है।",
  "sections": [
    {
      "heading": "IQ स्कोर क्या दर्शाता है",
      "paragraphs": [
        "आधुनिक आईक्यू परीक्षणों में सावधानी से डिज़ाइन किए गए कार्यों के परिणामों को जोड़ा जाता है और उन्हें एक प्रतिनिधि संदर्भ समूह के साथ तुलना की जाती है. स्केल आमतौर पर  पर केंद्रित होता है 100, तो एक परिणाम बुद्धि की एक पूर्ण मात्रा के बजाय सापेक्ष प्रदर्शन का वर्णन करता है।",
        "एक स्कोर को एक अनुमान के रूप में सबसे अच्छा समझा जाता है. परीक्षण की स्थिति, स्वास्थ्य, भाषा, प्रेरणा, परीक्षण प्रारूपों के साथ परिचितता और सामान्य माप त्रुटि सभी परिणाम को प्रभावित कर सकते हैं।"
      ]
    },
    {
      "heading": "IQ परीक्षण आम तौर पर क्या मूल्यांकन करते हैं",
      "paragraphs": [
        "पेशेवर बैटरी एक प्रकार के पहेली पर निर्भर होने के बजाय कई संज्ञानात्मक क्षमताओं का नमूना लेते हैं।"
      ],
      "bullets": [
        "मौखिक समझ और प्राप्त ज्ञान",
        "दृश्य-स्थानीय तथा तरल तर्क",
        "कार्यशील स्मृति तथा ध्यान",
        "प्रोसेसिंग गति"
      ]
    },
    {
      "heading": "IQ क्या मापता नहीं है",
      "paragraphs": [
        "IQ रचनात्मकता, व्यावहारिक निर्णय, जिज्ञासा, भावनात्मक कौशल, प्रेरणा, बुद्धि, या विशेषज्ञ ज्ञान को पूरी तरह से नहीं पकड़ता है।",
        "एक योग्य पेशेवर द्वारा पर्यवेक्षित मूल्यांकन नैदानिक, शैक्षिक या कानूनी निर्णयों के लिए अधिक उपयुक्त है।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ क्या है?",
      "answer": "IQ बुद्धि गुणांक के लिए खड़ा है, एक मानकीकृत स्कोर जो एक उम्र आधारित संदर्भ समूह के साथ चुने गए संज्ञानात्मक प्रदर्शन की तुलना करता है।"
    },
    {
      "question": "क्या एक ऑनलाइन आईक्यू परीक्षण एक निदान है?",
      "answer": "यह एक अप्राप्य ज्ञान है और इसे किसी भी प्रकार के वैज्ञानिक अध्ययन से प्राप्त नहीं किया जा सकता।"
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
